export const legal = `
Michael & Claudia Mindak, vonLuck (Einzelunternehmen).
Kontakt via E-Mail(cafe@von-luck.de).
Adresse Von-Luck-Straße 27, 14129 Berlin Nikolassee Deutschland
`;

export const copyright = "© 2021 vonLuck, All rights reserved.";
